<template>
  <BaseDialog
    type="basic"
    :is-open="isOpen"
    :title="$t('settings.organizationTeams.addMembers')"
    class="md:w-full"
    @close="cancel"
  >
    <BaseMemberSelect
      v-model="memberIds"
      include-self
      display-selected="list"
      :filtered-member-ids="memberIdsInTeam"
      :label="$t('settings.organizationTeams.members')"
      :error="showError ? $t('settings.organizationTeams.membersRequired') : ''"
    />
    <template #dismiss>
      <BaseTextButton color="text" @click="cancel">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton color="filled" @click="submit">{{
        $t('settings.organizationTeams.addMembers')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import { ref, watch } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseMemberSelect from '@/core/components/base/member-select/BaseMemberSelect.vue'

  interface Props {
    isOpen: boolean
    memberIdsInTeam: string[]
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'add', memberIds: string[]): void
  }>()

  const memberIds = ref<string[]>([])
  const showError = ref(false)

  watch(memberIds, () => {
    if (memberIds.value.length > 0) {
      showError.value = false
    }
  })

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen) {
        memberIds.value = []
        showError.value = false
      }
    },
  )

  const cancel = () => {
    emits('close')
  }

  const submit = () => {
    if (memberIds.value.length === 0) {
      showError.value = true
      return
    }
    emits('add', memberIds.value)
  }
</script>
